import { Icon } from '@natera/material/lib/icon'
import { cn } from '~/shared/lib/cn'

export function StepIcon({
  stepNumber,
  finished,
  active,
  skipped,
  flagged,
  flagSeverity = 'high',
}: {
  stepNumber: number
  finished: boolean
  active?: boolean
  skipped: boolean
  flagged?: boolean
  flagSeverity?: 'high' | 'low'
}) {
  if (skipped) {
    return (
      <span className="bg-content-medium-emphasis text-surface-lowest mr-2 size-6 rounded-full">
        <Icon children="remove" />
      </span>
    )
  }
  if (flagged) {
    return (
      <span
        className={cn('mr-2 flex size-6 items-center justify-center rounded-full', {
          'bg-alert-warning-message text-surface-lowest': flagSeverity === 'high',
          'bg-primary-main text-surface-lowest': flagSeverity === 'low',
        })}
      >
        <Icon
          children="flag"
          fill
          className="text-[18px]"
        />
      </span>
    )
  }
  if (finished) {
    return (
      <span className="bg-success-content text-surface-lowest mr-2 size-6 rounded-full">
        <Icon children="check" />
      </span>
    )
  }
  return (
    <span
      className={cn(
        'bg-content-medium-emphasis text-surface-lowest mr-2 flex size-6 items-center justify-center rounded-full text-sm leading-[18px] tracking-[0.15px]',
        {
          'bg-primary-main': active,
        },
      )}
    >
      {stepNumber}
    </span>
  )
}
